module.exports = __webpack_public_path__ + "img/360+.98ae4f44.png";